module.exports = __webpack_public_path__ + "img/traktor_yes.5f22d21d.png";